import React from 'react';
import { BaseComponent } from './BaseComponent.js';
import FontAwesome from 'react-fontawesome';

export class Header extends BaseComponent {
  constructor(props) {
    super(props);

    this.toggleMenu = this.toggleMenu.bind(this);
  }

  toggleMenu(e) {
    e.preventDefault();
    this.props.callbackToggleMenu();
  }

  render() {
    return (
      <div className="header">
        <div className="header__logo">
          <img className="header__logo__img" src={require('../images/unithings.png')} alt="Unithings"/>
        </div>
        <a href="#menu" onClick={ this.toggleMenu } className="header__menu">
          <FontAwesome name="bars" />
        </a>
        <a onClick={ this.logout } href="/logout" className="header__logout">
          <div className="header__logout__link">
            <FontAwesome name="sign-out-alt" />
            <span>Logout</span>
          </div>
        </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header.js